import React, { useState } from 'react';
import { Sidebar } from './components/Layout/Sidebar';
import { TopBar } from './components/Layout/TopBar';
import { Dashboard } from './pages/Dashboard';
import { HallOfFame } from './pages/HallOfFame';
import { VideoLibrary } from './pages/VideoLibrary';
import { Directory } from './pages/Directory';
import { Launchpad } from './pages/Launchpad';
import { LearningCenter } from './pages/LearningCenter';
import { MeetingRoom } from './pages/MeetingRoom';
export type Section = 'dashboard' | 'halloffame' | 'videos' | 'directory' | 'launchpad' | 'learning' | 'meetingroom';
function renderPage(section: Section) {
  switch (section) {
    case 'dashboard':
      return <Dashboard data-id="element-0" />;
    case 'halloffame':
      return <HallOfFame data-id="element-1" />;
    case 'videos':
      return <VideoLibrary data-id="element-2" />;
    case 'directory':
      return <Directory data-id="element-3" />;
    case 'launchpad':
      return <Launchpad data-id="element-4" />;
    case 'learning':
      return <LearningCenter data-id="element-5" />;
    case 'meetingroom':
      return <MeetingRoom data-id="element-6" />;
    default:
      return <Dashboard data-id="element-7" />;
  }
}
export function App() {
  const [activeSection, setActiveSection] = useState<Section>('dashboard');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  return <div style={{
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    background: '#F8FAFF'
  }} data-id="element-8">
      <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} data-id="element-9" />
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
      minWidth: 0
    }} data-id="element-10">
        <TopBar activeSection={activeSection} setActiveSection={setActiveSection} sidebarCollapsed={sidebarCollapsed} data-id="element-11" />
        <main style={{
        flex: 1,
        overflowY: 'auto',
        padding: '24px',
        background: '#F8FAFF'
      }} data-id="element-12">
          {renderPage(activeSection)}
        </main>
      </div>
    </div>;
}